const routes = [
  ['', '']
];

const meta = {
  base: '',
  heading: 'Logs',
  routes: () => routes
};

export default meta;
